import DynamicLottie from "@components/common/Lottie/LottieAnimation";
import {
  LottieWrapper,
  ParentWrapper,
  PrimaryText,
  RegistraionNumberLottieWrapper,
  RegNumberText,
  SecondaryText,
  Wrapper
} from "./styles";
import { useContext, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useOnload } from "@utils/useOnLoad";
import Lottie from "lottie-react";
import { LottieConstants } from "@components/common/Lottie/animations";
import { Context } from "@components/useContext/context";
import { useDispatch } from "react-redux";
import { updateLottieAnimationLoopCompletedd } from "@store/slices/lottieState";
import { allLottieAnimationComplete, skipLottieAnimation } from "@store/slices/lottieState";
import { useRouter } from "next/router";

const RegistraionNumberLottie = (props) => {
  const router = useRouter();
  const { registration_number } = router.query;
  const { isDesktop } = useContext(Context);
  const dispatch = useDispatch();
  const [initialAnimationKey, setInitialAnimationKey] = useState<string>(
    "REGISTRATION_NUMBER"
  );
  const [time, setTime] = useState<any>(false);
  const isInitialAnimation = initialAnimationKey === "REGISTRATION_NUMBER";
  const {
    showLottie,
    isLoading,
    isSuccess,
    showLottieFromLottie,
    lottieAnimationKeyfromLottie,
    customAnimationTextFromLottie,
    lottieAnimationLoopCompletedFromLottie,
    nextLottieAnimationKey,
    isNextAnimation,
    showInitialLottieFull,
    nextNodeSuccess,
    nextCustomAnimationText,
    redirectionDone,
    allState,
    isMmvDataFound,
    nextNodeUpcoming
  } = useSelector(({ configuration, lottieState }: any) => {
    return {
      currentNode: configuration?.config?.current_node,
      configAnimationKey: configuration?.lottieAnimationKey,
      isLoading: configuration?.isLoading,
      showLottie: configuration?.showLottie,
      isSuccess: configuration?.isSuccess,
      customAnimationText: configuration?.customAnimationText,
      lottieAnimationLoopCompleted: configuration?.lottieAnimationLoopCompleted,
      showLottieFromLottie: lottieState.showLottie,
      lottieAnimationKeyfromLottie: lottieState?.lottieAnimationKey,
      customAnimationTextFromLottie: lottieState.customAnimationText,
      lottieAnimationLoopCompletedFromLottie:
        lottieState.lottieAnimationLoopCompleted,
      nextLottieAnimationKey: lottieState.nextLottieAnimationKey,
      isNextAnimation: lottieState.isNextAnimation,
      showInitialLottieFull: lottieState.showInitialLottieFull,
      nextCustomAnimationText: lottieState.nextCustomAnimationText,
      nextNodeSuccess: lottieState.nextNodeSuccess,
      redirectionDone: lottieState.redirectionDone,
      allState: lottieState,
      isMmvDataFound: lottieState?.isMmvDataFound,
      nextNodeUpcoming: lottieState?.nextNodeUpcoming
    };
  });
  const {
    primarytext = "Looking for",
    secondaryText = "vehicle and policy details...",
    regNo,
    actions
  } = props;

  const { on_load } = actions || {};

  useOnload({ on_load });


  const handleLottieCycleComplete = (e) => {


    if (!nextNodeSuccess) {
      return;
    }

    if (
      isInitialAnimation &&
      isMmvDataFound &&
      nextNodeUpcoming !== "cng_confirmation_node"
    ) {
      setTimeout(() => {
        setInitialAnimationKey("WE_FOUND_YOUR_CAR");
      }, 1500);
    } else {
      setTimeout(() => {
        dispatch(
          updateLottieAnimationLoopCompletedd({
            lottieAnimationLoopCompleted: true
          })
        );
      }, 2000);
    }
  };

  const lottieStyles = {
    width: "200px"
  };

  const weFoundCarStyles = {
    width: "240px",
    height: "220px"
  };



  const handleFoundYourCarAnimationComplete = () => {
    console.log('isin', isInitialAnimation, initialAnimationKey)
    if (isInitialAnimation) return;
    setTimeout(() => {
      dispatch(
        updateLottieAnimationLoopCompletedd({
          lottieAnimationLoopCompleted: true
        })
      );
    }, 500);
  }

  return (
    <>
      {
        <>
          {!isDesktop && <Wrapper />}
          <ParentWrapper isDesktop={isDesktop}>
            <LottieWrapper>
              <RegistraionNumberLottieWrapper>
                {isInitialAnimation && (
                  <RegNumberText>
                    {String(registration_number || regNo).toUpperCase()}
                  </RegNumberText>
                )}
                <Lottie
                  animationData={LottieConstants[initialAnimationKey]}
                  loop={!isInitialAnimation ? 0.1 : true}
                  style={!isInitialAnimation ? weFoundCarStyles : lottieStyles}
                  autoplay={true}
                  onLoopComplete={handleLottieCycleComplete}
                  onComplete={handleFoundYourCarAnimationComplete}
                />
                {isInitialAnimation && (
                  <>
                    <PrimaryText>{primarytext}</PrimaryText>
                    <SecondaryText>{secondaryText}</SecondaryText>
                  </>
                )}
              </RegistraionNumberLottieWrapper>
            </LottieWrapper>
          </ParentWrapper>
        </>
      }
    </>
  );
};

export default RegistraionNumberLottie;


// http://localhost:3000/gi/auto-storefront/fresh-car?proposal_ekey=P9cDJ50yx8S--yxpmnYa-w&current_node=entry_node&registration_number=22BH1234A